import { render, staticRenderFns } from "./NumberManage.vue?vue&type=template&id=18886f2d&scoped=true&"
import script from "./NumberManage.vue?vue&type=script&lang=js&"
export * from "./NumberManage.vue?vue&type=script&lang=js&"
import style0 from "./NumberManage.vue?vue&type=style&index=0&id=18886f2d&prod&lang=scss&scoped=true&"
import style1 from "./NumberManage.vue?vue&type=style&index=1&id=18886f2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18886f2d",
  null
  
)

export default component.exports